// extracted by mini-css-extract-plugin
module.exports = {"report":"report_report__1Lim-","title":"report_title__DjE0t","review":"report_review__Je6Fk"};